//
//
//


import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
    name: "AppQueryFilter",
	components: {
	},
	props: {
        filter: Object
    },
	methods: {
        ...mapActions(["toggleFilter"]),
        toggle(option, operator = 'Equal') {
            // var identifier = option.identifier;
            // if (identifier.match(/^\d/)) {
            //     identifier = "filterOption" + identifier;
            // }
            // identifier = identifier.replaceAll('.','').replaceAll(',','_');
            this.toggleFilter({ field: this.filter.field, fieldDisplay: this.filter.display, value: option.identifier, valueDisplay: option.display, operator: operator });
        }
    }
};
